import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { MyDemandViewModel } from '../models/com/demand.model';
import { MOCK_DEMAND_RESPONSE } from '../shared/mocks/demand.mock';
import { ApiEndpointsService } from './api-endpoints.service';
import { SITES_DEMAND_QUERY } from '../shared/graphql/demand.query';
import { Site, SitesQueryResponse } from '../models/com/site.model';

@Injectable({
  providedIn: 'root'
})
export class DemandService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiEndpointsService);


  getLatestDemand(): Observable<MyDemandViewModel> {
    // Uncomment for mocked data
    //  const data = MOCK_DEMAND_RESPONSE;
    //  return of(this.transformSitesToMyDemandViewModel(data.data.sites));
    return this.getDemand({ perPage: 10 }).pipe(map(res =>
      //map the sites to displayOffers
      this.transformSitesToMyDemandViewModel(res?.data.sites)), catchError((err) => {
        console.error('Failed to load latest Offers', err); return of<MyDemandViewModel>({ sites: [], lastUpdate: '' });
      }));
  }

  getDemand(args?: { perPage: number }): Observable<SitesQueryResponse> {
    const endpoint = this.apiService.baseUrl;
    return this.http.post<SitesQueryResponse>(
      endpoint,{query: SITES_DEMAND_QUERY,variables: {perPage: args?.perPage },},{ withCredentials: true });
  }


 private transformSitesToMyDemandViewModel(sites: Site[]|null): MyDemandViewModel { 
  if(!sites || sites.length === 0) {
    return { sites: [], lastUpdate: '' };
  }

  return {
    sites: sites.map(site => { 
      const lastReading = site.demand?.readings?.sort((a,b) => new Date(b.end_time).getTime() - new Date(a.end_time).getTime())?.[0] ?? null;

      return {  
        name: site.display_labels || [],
        id: site.id,
        min: site.demand?.min ?? null,
        max: site.demand?.max ?? null,
        average: site.demand?.average ?? null,
        share: 0, // start UI share percentage on 0
        demand: lastReading?.value ?? 0,
      };
    }),
    // TODO: Use api last update when is ready in the mean time using local last update
    lastUpdate: new Date().toISOString()
  };
}


  
  
}
